'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The string value 'function'
 *
 * @module STR_FUNCTION
 * @constant
 * @type {string}
 * @default
 */

const STR_FUNCTION = 'function';

exports.default = STR_FUNCTION;